import React from 'react';
import IqamaDelay from './IqamaDelay';
import PrayerSettings from './PrayerSettings';
import TunePrayer from './TunePrayer';

const PrayerSettingsList = () => {
	

	return (
		<div className="grid divide-x-4 divide-slate-100 -space-x-3  c-mdx:divide-y-4  2xl:mx-6 xl:ml-5 md:mr-2 md:ml-4 ml-3 xl:grid-cols-[1fr_minmax(auto,_320px)_220px] 2xl:grid-cols-[1fr_minmax(auto,_450px)_250px]  sm:grid-rows-3 md:grid-rows-2 2xl:grid-rows-1 xl:grid-rows-1  gap-3  sm:grid-flow-col-dense  col-span-3">
			<div className={ '  md:col-span-2 xl:col-span-1 pr-2 ' }>
				<PrayerSettings />
			</div>

			<div className={ 'md:col-span-1  pl-2 pr-2 ' }>
				<TunePrayer />
			</div>
			<div className={ 'md:col-span-1 pl-2 pb-2' }>
				<IqamaDelay />
			</div>
		</div>
	);
};

export default PrayerSettingsList;
